export function validatePassewordChange(values) {
    let errors = {}

    if (!values.currentPassword)
        errors.currentPassword = "Current password is required"
    else if (!values.newPassword)
        errors.newPassword = "New password is required"
    else if (values.newPassword.length < 8)
        errors.newPassword = "Password can't be less than 8 characters"
    else if (!values.confirmPassword)
        errors.confirmPassword = "Password Confirmation is required"
    else if (values.newPassword !== values.confirmPassword)
        errors.confirmPassword = "Password don't match"

    return errors;
}